import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import type { ForwardedRef } from 'react';
import type { BankingOffer } from '@repo/supergraph/marketplace/types';
import { HeaderImageTitleWrapper } from './HeaderImageTitleWrapper';

type HeaderCells = {
  columnIndex: number;
  marketplaceEntity: BankingOffer;
  innerRef?: ForwardedRef<HTMLDivElement>;
  shouldNotDisplayCta?: boolean;
};

export const HeaderCells = ({
  columnIndex,
  marketplaceEntity,
  innerRef,
  shouldNotDisplayCta = false,
}: HeaderCells) => {
  return (
    <Box
      ref={innerRef}
      sx={{
        gridColumn: columnIndex + 1,
        gridRow: 2,
        display: 'flex',
        flexDirection: 'column',
        borderLeft: columnIndex === 0 ? '0px' : '1px solid',
        borderLeftColor: columnIndex === 0 ? 'transparent' : 'neutral.lighter',
        textAlign: 'center',
        px: 2,
        py: '1rem',
      }}
    >
      <HeaderImageTitleWrapper
        marketplaceEntity={marketplaceEntity}
        index={columnIndex}
        shouldNotDisplayCta={shouldNotDisplayCta}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: { xs: 'flex', md: 'none' },
              justifyContent: 'center',
            }}
          >
            <Image
              src={marketplaceEntity.image?.source || ''}
              alt=""
              width={0}
              height={0}
              style={{
                width: 'auto',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '65px',
              }}
            />
          </Box>
        </Box>
        <Box>
          <Typography
            sx={{
              color: 'neutral.darkest',
              textAlign: 'center',
              fontWeight: 500,
              lineHeight: '15px',
              letterSpacing: '0.813px',
              '&:hover': {
                textDecoration: 'underline',
              },
              fontSize: '14px',
            }}
          >
            {marketplaceEntity.displayName}
          </Typography>
        </Box>
      </HeaderImageTitleWrapper>
    </Box>
  );
};
